@if (alertCount > 0) {
  <div class="alert-banner">
    <div>
      <span class="material-symbols-outlined text-xl text-red-700">
        warning
      </span>
    </div>
    <div>
      You have {{ alertCount }} critical
      {{ alertCount > 1 ? "issues" : "issue" }} that
      {{ alertCount > 1 ? "require" : "requires" }} immediate attention. Please
      resolve {{ alertCount > 1 ? "them" : "it" }} before analyzing or exporting
      any data.
    </div>
    <div>
      <m-button
        type="tertiary"
        label="View more"
        (click)="navigateToNotificationCenter()" />
    </div>
  </div>
}
